import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import rem from '../src/utils/js/rem';
import echarts from 'echarts'
Vue.component('chart', echarts)
import store from './store/store'
import Print from 'vue-print-nb'

// 全局注册网络请求
import {post,postL,get,deletefn,put} from './utils/js/http';

Vue.prototype.rem = rem;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postL = postL;
Vue.prototype.$deletefn = deletefn;
Vue.prototype.$put = put;
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js